
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef, I18nModule } from '@spartacus/core';
import { RoutingService, TranslationService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { pairwise } from 'rxjs/operators';
import { CompanyModel } from 'src/app/core/model/company.model';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-custom-company-details',
    templateUrl: './custom-company-details.component.html',
    styleUrls: ['./custom-company-details.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, FormsModule, ReactiveFormsModule, I18nModule]
})
export class CustomCompanyDetailsComponent implements OnInit {
  myParam: string;
  enableLoader = true;
  errorMessage: any;
  title: any;
  website: string;
  socialmediaurl: string;
  userid: any;
  usergroup: any;
  navigationData: string;
  loggedinUser: any;
  admin: any;
  disableUser = true;
  i: any;
  groupcompanies: CompanyModel [] = [];
  error: string;
  // myForm: FormGroup;
  constructor(private cd: ChangeDetectorRef,
              public toastService: ToastService,
              private userAccountFacade: UserAccountFacade,
              private translation: TranslationService,
              private customProfileService: CustomProfileService,
              private router: Router,
              private customProductService: CustomProductsService,
              private winRef: WindowRef,
  ) { }

  ngOnInit(): void {
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.userAccountFacade.get().subscribe((data: any) => {
      if (data) {
        this.loggedinUser = data.roles[0];
        if (this.winRef.localStorage.getItem('groupCompanyAdminFlag') !== undefined) {
          this.admin = JSON.parse(this.winRef.localStorage.getItem('groupCompanyAdminFlag'));
        }
        this.userid = data.uid;
        this.usergroup = data.orgUnit.uid;
        this.getCompaniesData();
        this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              this.enableLoader = true;
              this.getCompaniesData();
            }
          }
        });
      }
    });
    this.translation.translate('breadcrumb.groupCompanyDetails.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.groupCompanyDetails.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.translation.translate('home.toastErrorMessages.dataSaved').subscribe(res => {
      this.error = res;
    });

  }

  getCompaniesData(): any{
    this.customProfileService.getGroupCompanies(this.usergroup).subscribe(res => {
      if (res) {
        this.enableLoader = false;
        let comData = res;
        comData = comData.myB2BUnits;
        this.groupcompanies.push(new CompanyModel(comData[0]));
        this.i = this.groupcompanies[0];
        this.cd.detectChanges();
      }
    }, (error) => {                              // Error callback
      console.error('error caught in component');
      this.errorMessage = error;
      this.enableLoader = false;
      // throw error;   //You can also throw the error to a global error handler
    });
  }

  updatedate(): any {
    this.disableUser = true;
    this.website = encodeURIComponent(this.website);
    if (!!this.website && !!this.socialmediaurl) {
      // tslint:disable-next-line:one-variable-per-declaration
      const queryString = '&socialMediaUrl=' + this.socialmediaurl + '&website=' + this.website;
      this.customProfileService.updateCompanyDetails(queryString, this.usergroup).subscribe(res => {
          this.toastService.show(this.error);
          this.navigateToLandingPage();
        }
        );
      return;
    }
    const queryString = '&socialMediaUrl=' + this.groupcompanies[0].socialMediaUrl + '&website=' + this.website;
    this.customProfileService.updateCompanyDetails(queryString, this.usergroup).subscribe(res => {
          this.toastService.show(this.error);
          this.navigateToLandingPage();
        });
    if (!!this.socialmediaurl) {
      const queryString = '&socialMediaUrl=' + this.socialmediaurl + '&website=' + this.groupcompanies[0].website;
      this.customProfileService.updateCompanyDetails(queryString, this.usergroup).subscribe(res => {
          this.toastService.show(this.error);
          this.navigateToLandingPage();
        });
    }
  }

  navigateToLandingPage(): any {
    this.router.navigate(['/companies/myCompany/groupcompanies/detail']);
  }
  disableSave(): any {
      this.disableUser = false;
  }
}
